import activityService from "../../services/activity.service";


export const state ={
    activities:[],


}
export const actions = {
    fetch_activities({commit}, page){
        return  activityService.getActivities(page).then(
            data => {    
                console.log(data);
                             
                commit ('SET_ACTIVITIES', data.activities);
                return Promise.resolve(data.activities);
            }, error => {
                commit('AssetsFailed');
                return Promise.reject(error);
            }
        );
    },


}
export const mutations = {
    
    SET_ACTIVITIES(state,activities){
        state.activities = activities
    },
}
export const getters = {
    get_activities(state){
        return state.activities 
    },

   
}


